
import React from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import InvoiceItem from './InvoiceItem';

let InvoiceItems = ({invoices, setInvoices, translate}) => {
  if (invoices){
    const invoicesI = invoices.invoices
    const invoiceItems = Object.keys(invoicesI).map((key, index) => {
      return (
        <InvoiceItem invoice={invoicesI[key]} translate={translate} key={invoicesI[key].id }/>
      );
    }
    )
  return  invoiceItems;
  }
  return (
    <div>
    </div>
  );
};
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    invoices: state.Invoices,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setInvoices: (invoices) => {
      dispatch(
        {
          type: 'SET_INVOICES',
          invoices: invoices,
        },
      );
    },
  }
}

InvoiceItems = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(InvoiceItems);

export default InvoiceItems;



// WEBPACK FOOTER //
// ./src/components/Invoices/InvoiceItems.js